// extracted by mini-css-extract-plugin
export default {"page":"Tabs_page__3J-uI","tab":"Tabs_tab__iHTkB","active":"Tabs_active__nTu88"};